
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      myself: {
        affiliation: `東京大学 大学院総合文化研究科
        広域科学専攻 相関基礎科学系 加藤雄介研究室
        助教`,
        text: '物性理論の研究者です．非従来型超伝導，トポロジカル物質科学，固体中の多極子モーメントなどのテーマに興味を持って研究しています．あるときは群論(表現論)やトポロジー，またあるときは有効模型の解析など，数理的・数値的手法を相補的に用いながら取り組んでいます．',
        imageFile: require('@/assets/top/profile.jpg')
      }
    }
  }
})
